import { useState } from "react";
import { sortTreatments } from "./SortingService";

export default function Treatments({ treatments, addTreatment, removeTreatment, showTreatments, selectedTreatments, handleBookNow, host }) {
  const AccordionItem = ({ treatment }) => {
    const [accordionOpen, setAccordionOpen] = useState(false);

    const toggleInfo = (accordion) => {
      setAccordionOpen(!accordionOpen);
    };

    return (
      <div className="accordion-item mb-2 border-top rounded rounded-2">
        <div className="accordion-header">
          <div
            className="accordion-button collapsed"
            data-bs-toggle="collapse"
            data-bs-target={`#concern_${treatment.serviceId}`}
            aria-expanded="false"
            onClick={(e) => toggleInfo(e)}
          >
            <div className="flex-column align-items-start">
              <h4>{treatment.title ? treatment.title : treatment.displayName}</h4>
              {!accordionOpen && (
                <>
                  {/* <p>{treatment.shortDesc}</p> */}
                  <p className="fw-bold mb-0">{treatment.price}</p>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="accordion-collapse collapse" data-bs-parent="#concernList" id={`concern_${treatment.serviceId}`}>
          <div className="accordion-body d-flex flex-column">
            <div className="row">
              <div className="col-12 col-sm-10">
                <p>{treatment.description ? treatment.description : treatment.shortDesc}{" "}
                  {treatment.serviceId === "50c19798-09d9-4f12-ba26-b14c00f71b2a" && (
                    <a href="/weight-loss" className="link-light link-offset-2 link-underline-opacity-100 link-underline-opacity-50-hover">Learn more</a>
                  )}</p>
              </div>
              <div className="col-12 col-sm-2">
                <div className="row pb-3">
                  <div className="col d-block d-sm-none">
                    <p className="fw-bold pb-2 pb-sm-0 text-sm-start">{treatment.price}</p>
                  </div>
                  <div className="col">
                    <p className="text-center mb-0 fs-13">
                      <strong>Duration</strong>
                      <br />
                      <small className="d-flex align-items-center justify-content-center mt-1">
                        {host && (
                          <img
                            className="me-1"
                            src={`//${host}/wp-content/plugins/services-selector/services-selector-module/assets/img/icon-clock--white.png`}
                            width="15"
                            height="15"
                            alt="clock"
                          />
                        )}{" "}
                        {treatment.duration}
                      </small>
                    </p>
                  </div>
                  {/* <div className="col border-end">
                    <p className="text-center mb-0 fs-13">
                      <strong>Sessions</strong>
                      <br />
                      <small className="d-flex align-items-center justify-content-center mt-1">
                        <i className="fa-solid fa-arrow-rotate-right me-1"></i> {treatment.sessions}
                      </small>
                    </p>
                  </div>
                  <div className="col">
                    <p className="text-center mb-0 fs-13">
                      <strong>Downtime</strong>
                      <br />
                      <small className="d-flex align-items-center justify-content-center mt-1">
                        {host && (
                          <img
                            className="me-1"
                            src={`//${host}/wp-content/plugins/services-selector/services-selector-module/assets/img/icon-sunrise.png`}
                            width="15"
                            height="15"
                            alt="sunrise"
                          />
                        )}{" "}
                        {treatment.downtime}
                      </small>
                    </p>
                  </div> */}
                </div>
              </div>
            </div>
            {treatment.id !== "bba7cb79-02ce-48eb-9383-b12a002161c1" && (
              <div className="row">
                <div className="col-12">
                  <ul className="ps-0">
                    {treatment.concerns.map((concern, index) => (
                      <li
                        key={`treatment_${treatment.slug}_${concern}`}
                        className={`d-inline-block badge rounded-pill fw-normal border border-1 border-white me-2 mb-2`}
                      >
                        <small>{concern.toLowerCase()}</small>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
            <div className="row d-none d-sm-block">
              <div className="col">
                <p className="fw-bold pb-2 pb-sm-0 text-sm-start">{treatment.price}</p>
              </div>
            </div>
            <div className="button-group text-center">
              <button type="button" className="btn btn-outline-primary btn-cta" onClick={() => handleBookNow(treatment)}>
                Book Appointment
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={`services-area__treatments ${showTreatments ? "show" : "hide"}`}>
      <div className="accordion" id="treatmentList">
        {!treatments.length && <div>No treatments found. Contact us if you're aving trouble: (203) 973-7829</div>}
        {treatments.sort(sortTreatments).map((treatment, index) => (
          <AccordionItem treatment={treatment} key={`treatment_${treatment.serviceId}`} />
        ))}
      </div>
    </div>
  );
}
